import React from 'react';
import {
  Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import isBackOffice from 'utils/appUtils';
import AgentProfileRedirect from 'agent-profile/AgentProfileRedirect';
import AgentProfileEdit from 'agent-profile/AgentProfileEdit';
import AgentProfileAdd from 'agent-profile/AgentProfileAdd';
import ApplicationsDashboard from 'applications-dashboard/ApplicationsDashboard';
import Welcome from 'welcome/Welcome';
import NextSteps from '../welcome/NextSteps';
import history from './history';

const RouterComponent = () => (
  <Router basename="/appraiser-registration" history={history}>
    <Switch>
      <Route path="/welcome" exact component={Welcome} />
      <Route path="/next-steps" exact component={NextSteps} />
      <Route path="/agent-register" exact component={AgentProfileAdd} />

      {isBackOffice && (
        <Route path="/dashboard" exact component={ApplicationsDashboard} />
      )}
      <Route path="/applications/:currentStep/:applicationId" component={AgentProfileEdit} />
      <Route
        path="/applications/:applicationId"
        component={AgentProfileRedirect}
      />
      <Redirect to="/welcome" />
    </Switch>
  </Router>
);

export default RouterComponent;
